import React, { ReactElement, FC, cloneElement } from "react";
import { Transition } from "react-transition-group";

import { TransitionProps } from "../types";

interface IFromElementProps extends TransitionProps {
  children: ReactElement;
}

const defaultStyle = {
  transitionProperty: "opacity, transform",
  transitionDuration: ".15s, .10s, .15s",
  transitionTimingFunction: "ease, ease, cubic-bezier(0.39, 0.575, 0.565, 1)",
  transformOrigin: "50% 0",
  transform: "scale(.85)",
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1, transform: "scale(1)", transitionDelay: ".6s" },
  entered: { opacity: 1, transform: "scale(1)" },
  exiting: { opacity: 0, transform: "scale(.85)" },
  exited: { opacity: 0, transform: "scale(.85)" },
};

export const FromElement: FC<IFromElementProps> = ({
  in: inProp = false,
  onEnter,
  onExited,
  children,
  style,
  timeout = 1000,
}) => {
  return (
    <Transition
      appear
      in={inProp}
      timeout={timeout}
      onEnter={onEnter}
      onExited={onExited}
    >
      {(state): ReactElement => {
        return cloneElement(children, {
          style: {
            visibility: state === "exited" && !inProp ? "hidden" : undefined,
            ...defaultStyle,
            ...transitionStyles[state],
            ...style,
            ...children.props.style,
          },
        });
      }}
    </Transition>
  );
};

FromElement.displayName = "FromElement";
